"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_insurance__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "591f702a-dd69-4484-a7d2-d210420f5b3b",
    x1: 87.23,
    y1: 90.53,
    x2: 108.33,
    y2: 111.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "c9b0a745-6dbf-4990-992a-a7d85de534f1",
    "data-name": "Insurance_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "250e886f-607d-42dd-8c31-6bf0f5189012",
    "data-name": "Bounding Box",
    points: "0.01 191.75 0.01 0.25 191.51 0.25 191.51 191.75 0.01 191.75",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.76,146.5a4,4,0,0,1-4-4V82.59a4,4,0,1,1,8,0V142.5A4,4,0,0,1,95.76,146.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.75 120.2 91.76 112.61 91.76 86 99.75 85.5 99.75 120.2",
    opacity: 0.2,
    fill: "url(#591f702a-dd69-4484-a7d2-d210420f5b3b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.76,139.21V148a4,4,0,0,1-8,0v-8.79",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.76,148v8.13c0,11.59-9.25,20-22,20S56,167.71,56,156.12a4,4,0,0,1,8,0c0,8.29,6.91,12,13.76,12s14-3.75,14-12V148",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.76,174.12c-12.12,0-21-7.77-21.7-18.66a4,4,0,0,0-.07.66c0,11.59,9.15,20,21.76,20s22-8.41,22-20v-2C99.76,165.71,90.51,174.12,77.76,174.12Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.92,93.93,23,94a4,4,0,0,0,4.49-.75c4.29-4.16,11.51-6.64,19.33-6.64,9.21,0,17.74,3.59,21.24,8.93a4,4,0,0,0,3.35,1.81h.17C72,88.39,74.91,48.43,95.51,19.5,36.24,28.12,24.57,84,22.92,93.93Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.51 19.5 95.51 19.5 95.52 19.5 95.51 19.5",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,19.5h0c20.56,28.88,23.52,68.75,23.93,77.76a3.94,3.94,0,0,0,4-1.75c3.5-5.34,12-8.93,21.24-8.93,7.82,0,15,2.48,19.33,6.64a4,4,0,0,0,4.14.88C167.11,84.71,155.68,28.18,96,19.5Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.92,93.93,23,94a4,4,0,0,0,4.49-.75c4.29-4.16,11.51-6.64,19.33-6.64,9.21,0,17.74,3.59,21.24,8.93a4,4,0,0,0,3.35,1.81h.17C72,88.39,74.91,48.43,95.51,19.5,36.24,28.12,24.57,84,22.92,93.93Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,19.5h0c20.56,28.88,23.52,68.75,23.93,77.76a3.94,3.94,0,0,0,4-1.75c3.5-5.34,12-8.93,21.24-8.93,7.82,0,15,2.48,19.33,6.64a4,4,0,0,0,4.14.88C167.11,84.71,155.68,28.18,96,19.5Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.28,90A75.51,75.51,0,0,0,111,22a21.81,21.81,0,0,0-30,0A75.51,75.51,0,0,0,20.72,90a4,4,0,0,0,2.2,3.88C24.57,84,36.24,28.12,95.51,19.5h0C74.91,48.43,72,88.39,71.58,97.31a4,4,0,0,0,3.18-1.8,16.65,16.65,0,0,1,5.53-5l.5-.29.19-.11c3.8-2.4,8.51-3.52,14.79-3.52H96a34.61,34.61,0,0,1,8.95,1.14,27.56,27.56,0,0,1,6.29,2.5,17,17,0,0,1,6,5.28,4,4,0,0,0,2.7,1.75c-.42-9-3.37-48.89-23.93-77.76h0c59.66,8.68,71.09,65.21,72.63,74.61.12,0,.24-.08.35-.13A4,4,0,0,0,171.28,90Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.2,89.21A4,4,0,0,1,169,92c-.11.05-.23.09-.35.13a4,4,0,0,1-4.14-.88c-4.29-4.16-11.51-6.64-19.33-6.64-9.21,0-17.74,3.59-21.24,8.93a4,4,0,0,1-6.69,0,17,17,0,0,0-6-5.28,27.56,27.56,0,0,0-6.29-2.5A34.61,34.61,0,0,0,96,84.59h-.23c-6.28,0-11,1.12-14.79,3.52l-.19.11-.5.29a16.65,16.65,0,0,0-5.53,5,4,4,0,0,1-3.18,1.8h-.17a4,4,0,0,1-3.35-1.81c-3.5-5.34-12-8.93-21.24-8.93-7.82,0-15,2.48-19.33,6.64A4,4,0,0,1,23,92l-.08,0a4,4,0,0,1-2.12-2.72c0,.28-.06.55-.08.83a4,4,0,0,0,2.2,3.88L23,94a4,4,0,0,0,4.49-.75c4.29-4.16,11.51-6.64,19.33-6.64,9.21,0,17.74,3.59,21.24,8.93a4,4,0,0,0,3.35,1.81h.17a4,4,0,0,0,3.18-1.8,16.65,16.65,0,0,1,5.53-5l.5-.29.19-.11c3.8-2.4,8.51-3.52,14.79-3.52H96a34.61,34.61,0,0,1,8.95,1.14,27.56,27.56,0,0,1,6.29,2.5,17,17,0,0,1,6,5.28,4,4,0,0,0,6.69,0c3.5-5.34,12-8.93,21.24-8.93,7.82,0,15,2.48,19.33,6.64a4,4,0,0,0,4.14.88c.12,0,.24-.08.35-.13A4,4,0,0,0,171.28,90C171.26,89.77,171.23,89.49,171.2,89.21Z",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("title", null, "insurance-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "97ec3913-bdd2-40ff-b76b-92a4e9a4219d",
    "data-name": "Insurance_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "539bd9c9-da31-4ba8-90ed-45ade709a13d",
    "data-name": "Insurance_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0.24 0)",
    xlinkHref: "#c9b0a745-6dbf-4990-992a-a7d85de534f1"
  })));
}

var _default = ic_insurance__dark;
exports.default = _default;